import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Management extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get person() {
    return get(this, '_czlonek_zarzadu.value[0]', {});
  }

  get image() {
    return get(this, '_zdjecie_strona_glowna.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Management.model.js